import styled from 'styled-components'


export const HeadlineSearchContainer = styled.div`
    max-width: 80%;
	margin-top: 20px;
	position: relative;
	
`
export const SearchText = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 14px;
  cursor: pointer;
	color: #8f8f8f;
	display: flex;
	align-items: center;
	gap: 15px;
	margin-bottom: 10px;
`


export const Input = styled.input`
	flex: 1;
	border: none;
	outline: none;
	padding: 6px 14px;
	font-weight: 400;
	font-size: 14px;
	color: #333;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

	&::placeholder {
		color: #d9d9d9;
	}

  @media(max-width: 1024px) {
   	font-size: 12px;
  }

   @media(max-width: 768px) {
   	font-size: 11px;
  }

	@media(max-width: 425px) {
	padding: 6px 3px;
	font-size: 13px;
	}
`

export const ClearButton = styled.button`
	border: none;
	background: transparent;
	margin-right: 60px;
	font-size: 18px;
	cursor: pointer;
	color: #0a8f44;

	@media(max-width: 425px) {
		margin-right: 38px;
		padding: 0;
	}
`

export const Button = styled.button`
	position: absolute;
	right: -80px;
	border: none;
	padding: 12px 26px;
	border-radius: 30px;
	background: #0a8f44;
	color: white;
	font-size: 16px;
	font-weight: 500;
	cursor: pointer;

	@media(max-width: 425px) {
	  font-size: 13px;
	}
`

export const DropdownList = styled.ul`
	position: absolute;
	top: 100%;
	left: 0;
	width: 100%;
	background: white;
	border: 0.5px solid #01924f;
	margin-top: 4px;
	padding: 0;
	list-style: none;
	z-index: 1000;
	max-height: 200px;
	overflow-y: auto;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

    &::-webkit-scrollbar {
        width: 12px; 
      
    }
    &::-webkit-scrollbar-button {
        display: none;
        width: 0;
        height: 0;
    }
    &::-webkit-scrollbar-track {
        margin-left: 10px;
        box-shadow: inset 0 0 5px #f1f1f1; 
        background-color: transparent;
		margin-top: 5px;    
        margin-bottom: 5px
        border-radius: 10px; 
    }

    &::-webkit-scrollbar-thumb {
        background-color: #01904e; 
        border: 4px solid transparent;
        background-clip: padding-box; 
        border-radius: 10px;

        &:hover {
            background-color: #0a8f44; 
        }
	}
`

export const DropdownItem = styled.li`
	padding: 10px 15px;
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 15px;
	color: #484848;
	cursor: pointer;

	&:hover {
		background-color: #d9ffed; 
	}
`







export const HeadlineContainer = styled.div`
  display: flex;

  justify-content: space-between;
  width: 100%;
  gap: 20px;

  @media(max-width: 530px) {
    align-items: center; 
  }

`

export const HeadlineActionsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  flex: 1;
  min-width: 0; 
  
   @media (max-width: 768px) {
     flex: 0.7;
  }

`

export const HeadlineTextColumn = styled.div`
  font-family: 'e-Ukraine', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 114%;
  text-align: justify;
  color: #484848;
  max-width: 730px;
  padding-bottom: 35px;
  flex: 1;
  min-width: 0;  /* ← то же самое */

  @media (max-width: 1024px) {
    font-size: 14px;
  }

  @media (max-width: 768px) {
    max-width: 100%;
	font-size: 12px;
    padding-bottom: 0;
  }
`

export const HeadlineTitle = styled.div`
  font-family: 'e-Ukraine-Head', sans-serif;
  font-weight: 400;
  font-size: 48px;
  line-height: 52px;
  text-transform: uppercase;
  color: #555;

  @media (max-width: 1024px) {
    font-size: 36px;
    line-height: 40px;
  }

 
  @media (max-width: 530px) {
   font-size: 16px;
   line-height: 21px;
  }
`

export const SearchWrapper = styled.div`
  margin-left: 35px;
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 630px;
  border: 0.5px solid #01924f;
  border-radius: 0 20px 20px 20px;
  padding: 6px;
  background: #fff;


  @media(max-width: 425px) {
   margin-left: 3px; 
   max-width: 280px;
   padding: 5px;
  } 
`

export const HeadlineWrapper = styled.div`
  max-width: 1440px;
  padding: 45px 10px 33px 10px; 
  margin: 0 auto;

  @media(max-width: 768px) {
   padding: 80px 10px 33px 10px; 
  }
`

export const SearchOverlay = styled.div<{ $isVisible: boolean }>`
  display: none;

  @media (max-width: 425px) {
    display: ${props => props.$isVisible ? 'flex' : 'none'};
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 200;
    align-items: flex-start;
  }
`
